import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import _ from "lodash";
import cx from "classnames";
import styles from "./styles.module.scss";

const NotesViewer = ({ asset, onClose }) => {
    const [activePage, setActivePage] = useState<number>(1);
    const [showMask, setShowMask] = useState<boolean>(true);
    const notesContainerRef = useRef<HTMLDivElement>(null);

    const notes = useSelector((state) =>
        _.get(state, `asset.preview.item.pages[${activePage - 1}].noteDTO.text`, "")
    );

    useEffect(() => {
        const scrollContainer = document.getElementById(`viewer_${asset.id}`);
        if (!scrollContainer) return;

        const handleScroll = () => {
            const pages = Array.from(scrollContainer.querySelectorAll<HTMLElement>(".page"));
            if (pages.length === 0) return;

            const containerRect = scrollContainer.getBoundingClientRect();
            const containerMid = containerRect.top + containerRect.height / 2;

            let closestPage = pages[0];
            let closestDiff =
                Math.abs((closestPage.getBoundingClientRect().top + closestPage.getBoundingClientRect().height / 2) - containerMid);

            for (let i = 1; i < _.size(pages); i++) {
                const rect = pages[i].getBoundingClientRect();
                const pageMid = rect.top + rect.height / 2;
                const diff = Math.abs(pageMid - containerMid);

                if (diff < closestDiff) {
                    closestDiff = diff;
                    closestPage = pages[i];
                }
            }

            const currentPage = closestPage.getAttribute("data-page-number") || "1";
            setActivePage(Number(currentPage));
        };

        handleScroll();
        scrollContainer.addEventListener("scroll", handleScroll);
        return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }, [asset.id]);


    const paragraphs = notes
        ? notes.split(/\n{2,}|\r\n{2,}/)
        .map(p => p.trim())
        .filter(Boolean)
        : [];

    return (
        <div className={styles.container}>
            <p className={styles.title}>notes</p>

            <div
                ref={notesContainerRef}
                className={cx(styles.text, {
                    [styles.noMask]: !showMask,
                })}
            >
                {paragraphs.length > 0 ? (
                    paragraphs.map((paragraph, index) => (
                        <p key={index} className={styles.paragraph}>
                            {paragraph.replace(/\n/g, ' ')}
                        </p>
                    ))
                ) : (
                    'No notes found'
                )}
            </div>
        </div>
    );
};

export default NotesViewer;
